import { createFileRoute, redirect } from '@tanstack/react-router'

import {
  FEATURE_START_ROUTE_LEARNING_PATH_DYNAMIC,
  FEATURE_START_ROUTE_LEARNING_PATH_STATIC,
} from '@/core/constants/features'
import { usersQueries } from '@/http/api/users'

let isInitialLoad = true

export const Route = createFileRoute('/_learning/home/_overview/')({
  beforeLoad: async ({ context: { user, queryClient }, search }) => {
    if (!isInitialLoad) return
    isInitialLoad = false

    // if any of the search params are present, do not redirect to learnpaths
    if (
      search['certificate-congratulations'] !== undefined ||
      search['learningpath-finished'] !== undefined ||
      search['learningpath-invite'] !== undefined
    ) {
      return
    }

    // Feature flag: static learning path homepage — always go to /learnpaths after login
    if (user?.features.includes(FEATURE_START_ROUTE_LEARNING_PATH_STATIC)) {
      throw redirect({ to: '/learnpaths', state: { restoreFilters: true } })
    }

    // Feature flag: dynamic learning path homepage — go to /learnpaths after login only if any of the learnpaths is incomplete
    if (user?.features.includes(FEATURE_START_ROUTE_LEARNING_PATH_DYNAMIC)) {
      const userState = await queryClient.ensureQueryData(
        usersQueries.usersCurrentState(),
      )
      const hasIncompleteLearnpaths = Boolean(
        userState?.learnpaths &&
        userState.learnpaths.num_learnpaths_assigned > 0 &&
        userState.learnpaths.num_learnpaths_completed <
          userState.learnpaths.num_learnpaths_assigned,
      )

      if (hasIncompleteLearnpaths) {
        throw redirect({ to: '/learnpaths', state: { restoreFilters: true } })
      }
    }
  },
})
